module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/tab-bar/tab-bar.component.scss
// module id = ./src/app/modules/common-module/components/tab-bar/tab-bar.component.scss
// module chunks = 9